import api from './api';

/**
 * Obtener todos los proyectos
 */
export const getProjects = async (params = {}) => {
  try {
    console.log('📡 [projectsService] Enviando petición GET a:', '/api/configuration/projects');
    console.log('📋 [projectsService] Parámetros:', params);
    
    const response = await api.get('/configuration/projects', { params });
    
    console.log('✅ [projectsService] Respuesta recibida exitosamente');
    console.log('📦 [projectsService] Response completo:', response);
    console.log('📊 [projectsService] Response.data:', response.data);
    console.log('🔍 [projectsService] Tipo de response.data:', typeof response.data);
    console.log('📈 [projectsService] response.data.success:', response.data?.success);
    console.log('📋 [projectsService] response.data.data:', response.data?.data);
    console.log('🔢 [projectsService] Cantidad de proyectos:', Array.isArray(response.data?.data) ? response.data.data.length : 'No es un array');
    
    if (Array.isArray(response.data?.data)) {
      console.log('📝 [projectsService] Primeros 3 proyectos:', response.data.data.slice(0, 3));
      console.log('🔑 [projectsService] Estructura de un proyecto:', response.data.data[0] ? Object.keys(response.data.data[0]) : 'No hay proyectos');
    }
    
    return response.data;
  } catch (error) {
    console.error('❌ [projectsService] Error al obtener proyectos:', error);
    console.error('📊 [projectsService] Error.response:', error.response);
    console.error('📋 [projectsService] Error.response?.data:', error.response?.data);
    console.error('🔢 [projectsService] Error.status:', error.response?.status);
    throw error;
  }
};

/**
 * Obtener un proyecto por ID
 */
export const getProject = async (id) => {
  try {
    const response = await api.get(`/configuration/projects/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener proyecto:', error);
    throw error;
  }
};

/**
 * Crear un nuevo proyecto
 */
export const createProject = async (projectData) => {
  try {
    console.log('📡 [projectsService] Enviando petición POST a:', '/api/configuration/projects');
    console.log('📤 [projectsService] Datos a enviar:', projectData);
    
    const response = await api.post('/configuration/projects', projectData);
    
    console.log('✅ [projectsService] Proyecto creado exitosamente');
    console.log('📦 [projectsService] Response completo:', response);
    console.log('📊 [projectsService] Response.data:', response.data);
    console.log('🔍 [projectsService] Proyecto creado:', response.data?.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ [projectsService] Error al crear proyecto:', error);
    console.error('📊 [projectsService] Error.response:', error.response);
    console.error('📋 [projectsService] Error.response?.data:', error.response?.data);
    throw error;
  }
};

/**
 * Actualizar un proyecto
 */
export const updateProject = async (id, projectData) => {
  try {
    console.log('📡 [projectsService] Enviando petición PUT a:', `/api/configuration/projects/${id}`);
    console.log('📤 [projectsService] ID de proyecto:', id);
    console.log('📤 [projectsService] Datos a enviar:', projectData);
    
    const response = await api.put(`/configuration/projects/${id}`, projectData);
    
    console.log('✅ [projectsService] Proyecto actualizado exitosamente');
    console.log('📦 [projectsService] Response completo:', response);
    console.log('📊 [projectsService] Response.data:', response.data);
    console.log('🔍 [projectsService] Proyecto actualizado:', response.data?.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ [projectsService] Error al actualizar proyecto:', error);
    console.error('📊 [projectsService] Error.response:', error.response);
    console.error('📋 [projectsService] Error.response?.data:', error.response?.data);
    throw error;
  }
};

/**
 * Eliminar un proyecto
 */
export const deleteProject = async (id) => {
  try {
    console.log('📡 [projectsService] Enviando petición DELETE a:', `/api/configuration/projects/${id}`);
    console.log('📤 [projectsService] ID de proyecto a eliminar:', id);
    
    const response = await api.delete(`/configuration/projects/${id}`);
    
    console.log('✅ [projectsService] Proyecto eliminado exitosamente');
    console.log('📦 [projectsService] Response completo:', response);
    console.log('📊 [projectsService] Response.data:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ [projectsService] Error al eliminar proyecto:', error);
    console.error('📊 [projectsService] Error.response:', error.response);
    console.error('📋 [projectsService] Error.response?.data:', error.response?.data);
    throw error;
  }
};

